export default "__VITE_ASSET__C5o9chC1__"